/*
 * DO NOT WRITE OR UPDATE THIS FILE!
 * This file was automatically generated at: 2024-11-22T12:12:47.125Z
 */
const VERSION = '6.0.0';
export default VERSION;
